import { Locale } from '@/store/types'

export const getLocales = () => Object.values(Locale)
export const getDefaultLocale = () => Locale.English
